var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Rating_Info"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rating_Info",
    "data-name": "Rating Info",
    clipPath: "url(#clip-Rating_Info)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9053",
    "data-name": "Group 9053",
    transform: "translate(14535.84 -14094.41)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_258",
    "data-name": "Ellipse 258",
    cx: 8.41,
    cy: 8.41,
    r: 8.41,
    transform: "translate(-14535.25 14095)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9030",
    "data-name": "Group 9030",
    transform: "translate(-14529.083 14099.021)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18994",
    "data-name": "Path 18994",
    d: "M0,0,3.323,3.323",
    transform: "translate(2.35 3.774) rotate(45)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_374",
    "data-name": "Ellipse 374",
    cx: 1.138,
    cy: 1.138,
    rx: 1.138,
    ry: 1.138,
    transform: "translate(1.213 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRatingInfo);
export default __webpack_public_path__ + "static/media/Rating Info.cdfa70d018ab90ffca4f9b4b0e180251.svg";
export { ForwardRef as ReactComponent };